export const PROGRAM_URLS = {
  POC: {
    requirements: 'https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Sell&article=POC-Quick-Reference',
    benefits: 'https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Sell&article=POC-Full-Benefits-and-Offerings'
  },
  MDF: {
    requirements: 'https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Market&article=Marketing-Development-Funds-MDF',
    benefits: 'https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Market&article=Marketing-Development-Funds-MDF-full-benefits-and-offerings'
  },
  Misc: {
    requirements: 'https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Sell&article=AWS-ISV-Workload-Migration-Program-WMP',
    benefits: 'https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Sell&article=ISV-Workload-Migration-Program-WMP-full'
  },
  Sandbox: {
    requirements: 'https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Build&article=Sandbox-Quick-Reference',
    benefits: 'https://partnercentral.awspartner.com/partnercentral2/s/article?category=Funding_Build&article=Sandbox-Full-Benefits-and-Offerings'
  }
};